function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eaf0f5;}.cls-2{fill:#7cb2ff;}.cls-3{fill:#ffd875;}.cls-4{fill:#ffb12f;}.cls-5{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M40.5412,17.2616a3.6402,3.6402,0,0,0-5.14073-.29425s-.80057.7139-2.0401,1.8206a3.59688,3.59688,0,0,0-3.78468-2.88632c.61581-.51358,1.2163-1.0142,1.77616-1.48059a3.64121,3.64121,0,0,0-4.66156-5.595s-4.23136,3.52553-8.46312,7.067c-2.11876,1.7734-4.23753,3.55083-5.82651,4.8927-3.6375,3.07171-3.93486,3.3228-3.93486,5.05758A3.63668,3.63668,0,0,0,11.456,29.41882c-3.57826,2.859-3.81022,3.113-3.81022,4.83743a3.64109,3.64109,0,0,0,6.17632,2.61345c.44068-.37447,2.11433-1.71427,4.37416-3.51083a5.51916,5.51916,0,0,0-.04016.7449A3.641,3.641,0,0,0,24.48572,36.559c1.08762-1.044,10.17071-9.17154,15.76123-14.15668A3.641,3.641,0,0,0,40.5412,17.2616Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M14.98958,13.34275a.32685.32685,0,0,1-.46167-.0225l-.58021-.64141a.32727.32727,0,0,1,.4854-.4391l.58025.64144A.32682.32682,0,0,1,14.98958,13.34275Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M16.55175,15.06966a.32684.32684,0,0,1-.46167-.02251l-.58022-.6414a.32727.32727,0,0,1,.48541-.4391l.58024.64143A.32686.32686,0,0,1,16.55175,15.06966Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M16.66787,12.81146l-.64315.58179a.3264.3264,0,1,1-.43793-.48412l.64314-.58179a.32641.32641,0,1,1,.43794.48412Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M14.93636,14.37779l-.64308.58173a.32641.32641,0,1,1-.43794-.48412l.64315-.58179a.32641.32641,0,1,1,.43787.48418Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M9.01437,24.07717A.19992.19992,0,0,1,8.732,24.0634l-.3549-.39233a.20019.20019,0,0,1,.29691-.26859l.35492.39235A.19992.19992,0,0,1,9.01437,24.07717Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M9.96991,25.13347a.19992.19992,0,0,1-.28239-.01377l-.35491-.39233a.20018.20018,0,0,1,.29691-.26858l.35492.39235A.19992.19992,0,0,1,9.96991,25.13347Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M10.04094,23.75219l-.3934.35587a.19965.19965,0,1,1-.26787-.29613l.39339-.35586a.19965.19965,0,1,1,.26788.29612Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M8.98182,24.71027l-.39336.35583A.19965.19965,0,1,1,8.32059,24.77l.39339-.35586a.19965.19965,0,1,1,.26784.29615Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M35.78045,34.78612a.19992.19992,0,0,1-.28239-.01377L35.14315,34.38a.20019.20019,0,0,1,.29691-.26859l.35492.39235A.19991.19991,0,0,1,35.78045,34.78612Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M36.736,35.84242a.19992.19992,0,0,1-.28239-.01377l-.3549-.39233a.20018.20018,0,0,1,.29691-.26858l.35492.39235A.19993.19993,0,0,1,36.736,35.84242Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M36.807,34.46114l-.39339.35587a.19966.19966,0,1,1-.26788-.29613l.3934-.35586a.19965.19965,0,1,1,.26787.29612Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M35.74789,35.41922l-.39335.35583a.19965.19965,0,1,1-.26788-.29612l.3934-.35587a.19965.19965,0,1,1,.26783.29616Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M12.83119,38.17863l.68878-.142a.31056.31056,0,0,0,0-.60664l-.68878-.142a1.73845,1.73845,0,0,1-1.3469-1.36955l-.13967-.70038a.30341.30341,0,0,0-.59661,0l-.13967.70038A1.73846,1.73846,0,0,1,9.26144,37.288l-.68879.142a.31056.31056,0,0,0,0,.60664l.68879.142a1.73848,1.73848,0,0,1,1.3469,1.36955l.13967.70038a.30341.30341,0,0,0,.59661,0l.13967-.70038A1.73852,1.73852,0,0,1,12.83119,38.17863Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M9.12871,13.16473l.3087-.06364a.13919.13919,0,0,0,0-.27189l-.3087-.06365a.77912.77912,0,0,1-.60365-.6138l-.0626-.31389a.136.136,0,0,0-.26738,0l-.0626.31389a.77914.77914,0,0,1-.60365.6138l-.3087.06365a.13919.13919,0,0,0,0,.27189l.3087.06364a.77916.77916,0,0,1,.60365.61381l.0626.31389a.136.136,0,0,0,.26738,0l.0626-.31389A.77917.77917,0,0,1,9.12871,13.16473Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M30.5948,40.15509l.28452-.05866a.12828.12828,0,0,0,0-.25058l-.28452-.05867a.7181.7181,0,0,1-.55636-.56571l-.05769-.2893a.12533.12533,0,0,0-.24644,0l-.05769.2893a.7181.7181,0,0,1-.55636.56571l-.28452.05867a.12828.12828,0,0,0,0,.25058l.28452.05866a.71812.71812,0,0,1,.55636.56572l.05769.2893a.12533.12533,0,0,0,.24644,0l.05769-.2893A.71814.71814,0,0,1,30.5948,40.15509Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M26.65187,30.65674a2.96186,2.96186,0,0,1-2.97,2.96,3.10114,3.10114,0,0,1-.69-.08,2.96525,2.96525,0,0,1,0-5.77,3.10468,3.10468,0,0,1,.69-.08A2.9704,2.9704,0,0,1,26.65187,30.65674Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M25.26185,30.65674a2.95042,2.95042,0,0,1-2.27,2.88,2.96525,2.96525,0,0,1,0-5.77A2.96182,2.96182,0,0,1,25.26185,30.65674Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M32.21186,27.94672h-17.06l1.47-8.07.12-.67a6.53891,6.53891,0,0,1,6.25-5.36.3421.3421,0,0,1,.1-.00995h1.18a6.54917,6.54917,0,0,1,6.35,5.37l.08.44Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M30.83186,27.94672h-15.68l1.47-8.07.12-.67a6.53891,6.53891,0,0,1,6.25-5.36,6.5473,6.5473,0,0,1,6.25,5.36l.08.44Z"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 13.54891,
  y: 27.09132,
  width: 20.26757,
  height: 3.6888,
  rx: 1.8444
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M17.93013,18.86536a.12082.12082,0,0,1-.02637-.00293.1249.1249,0,0,1-.0957-.14844,5.22788,5.22788,0,0,1,4.35156-4.27392.12506.12506,0,0,1,.02344.249,4.89557,4.89557,0,0,0-4.13086,4.07764A.12508.12508,0,0,1,17.93013,18.86536Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M20.74263,22.08021a2.71414,2.71414,0,0,1-1.76563-.56788.37484.37484,0,0,1,.5-.55859c.05078.04346,1.04688.85742,2.94629-.05762a.37519.37519,0,0,1,.32617.67579A4.612,4.612,0,0,1,20.74263,22.08021Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M26.33149,22.08021a2.71409,2.71409,0,0,1-1.76562-.56788.375.375,0,0,1,.5-.55908c.04883.042,1.04687.86133,2.94629-.05713a.37519.37519,0,0,1,.32617.67579A4.612,4.612,0,0,1,26.33149,22.08021Z"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 23.70387,
  cy: 24.25301,
  r: 0.71701
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M32.15509,16.4778l1.92722-2.61469a.379.379,0,0,0,.07391-.22486V13.452a.379.379,0,0,0-.379-.379H31.59966a.379.379,0,0,0-.379.379h0a.379.379,0,0,0,.379.379h1.61816l-1.97591,2.59724a.379.379,0,0,0-.07736.22946v.19907a.379.379,0,0,0,.379.379h2.342a.379.379,0,0,0,.379-.379h0a.379.379,0,0,0-.379-.379Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M27.84741,13.0847,30.2692,9.799a.47623.47623,0,0,0,.09288-.28255v-.234a.47622.47622,0,0,0-.47623-.47622H27.14944a.47622.47622,0,0,0-.47622.47622h0a.47622.47622,0,0,0,.47622.47623h2.03341l-2.483,3.26375a.47621.47621,0,0,0-.09721.28834v.25016a.47623.47623,0,0,0,.47622.47623h2.943a.47623.47623,0,0,0,.47622-.47623h0a.47623.47623,0,0,0-.47622-.47623Z"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 32.32797,
  cy: 19.06429,
  r: 0.45245
});

var SvgEmptyNotification = function SvgEmptyNotification(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-notification.a1bd55dc.svg";
export { ForwardRef as ReactComponent };